export const ACCOUNT_DELETION_CALLBACK_PATH = '/api/auth/delete-user/callback'
export const ACCOUNT_DELETION_CONTINUE_PATH = '/profil-torles-megerosites'

export async function mapAccountDeletionResponse(
  request: Request,
  response: Response,
): Promise<Response> {
  const url = new URL(request.url)
  if (
    request.method !== 'GET' ||
    url.pathname !== ACCOUNT_DELETION_CALLBACK_PATH ||
    response.status !== 404
  ) {
    return response
  }

  let error: unknown
  try {
    error = await response.clone().json()
  } catch {
    return response
  }
  if (!error || typeof error !== 'object' || !('code' in error)) return response

  // Relative locations: behind Railway's proxy request.url carries the internal
  // host (https://localhost:3000), not the public one.
  let destination: string
  if (error.code === 'FAILED_TO_GET_USER_INFO') {
    // Login blocks /api/ redirects; this public route resumes only the deletion callback.
    const params = new URLSearchParams({ redirect: ACCOUNT_DELETION_CONTINUE_PATH + url.search })
    destination = `/belepes?${params}`
  } else if (error.code === 'INVALID_TOKEN') {
    destination = '/profil-beallitasok?deletionError=invalid-token'
  } else {
    return response
  }

  const headers = new Headers({ Location: destination, 'Cache-Control': 'no-store' })
  // Keep Better Auth's cookie updates, including removal of an expired session.
  for (const cookie of response.headers.getSetCookie()) {
    headers.append('Set-Cookie', cookie)
  }
  return new Response(null, { status: 302, headers })
}
